import { EnumResponse } from '@/api/services/common.dto'

export enum ReportTemplateType {
    CASE_REPORT = 'CASE_REPORT',
    CASE_LABEL = 'CASE_LABEL',
    SAMPLE_LABEL = 'SAMPLE_LABEL',
    REQUEST_REPORT = 'REQUEST_REPORT',
    SUBREQUEST_LABEL = 'SUBREQUEST_LABEL',
    CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL = 'CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
    PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL = 'PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL',
    SUBPORTION_LABEL = 'SUBPORTION_LABEL',
    INCIDENT_REPORT = 'INCIDENT_REPORT',
    PATIENT_PREVIOUS_CASES = 'PATIENT_PREVIOUS_CASES',
    REQUEST_GRID_REPORT = 'REQUEST_GRID_REPORT',
    MACROS_REPORT = 'MACROS_REPORT',
    CYTOLOGY_SAMPLE_LABEL = 'CYTOLOGY_SAMPLE_LABEL',
    SHIPMENT_REPORT = 'SHIPMENT_REPORT',
    CASE_SUMMARY_PATHOLOGIST_REPORT = 'CASE_SUMMARY_PATHOLOGIST_REPORT',
    CASE_SUMMARY_PATIENT_REPORT = 'CASE_SUMMARY_PATIENT_REPORT',
    BILLABLE_DELIVERY_NOTE_REPORT = 'BILLABLE_DELIVERY_NOTE_REPORT',
    INVOICE_REPORT = 'INVOICE_REPORT'
}

export interface ReportTemplatePatchInBatchRequest {
    id: number
    name?: string
    filename?: string
}

export interface ReportTemplateCreateRequest {
    name: string
    filename: string
    type: ReportTemplateType
}

export interface ReportTemplateResponse {
    id: number
    name: string
    filename: string
    type: EnumResponse
}
